// extracted by mini-css-extract-plugin
export var title = "style-module--title--60696";
export var titleContainer = "style-module--titleContainer--fd46d";